/* Potencia Partners — site interactions */
(function () {
  document.querySelectorAll("[data-year]").forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  var toggle = document.querySelector(".nav-toggle");
  var menu = document.querySelector(".mobile-menu");
  if (toggle && menu) {
    toggle.addEventListener("click", function () { menu.classList.toggle("open"); });
  }

  var toast = document.getElementById("toast");
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (msg) toast.querySelector("span").textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2800);
  }
  document.querySelectorAll("[data-soq]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      showToast("SOQ download started");
    });
  });

  var form = document.getElementById("contact-form");
  if (form && !form.getAttribute("action")) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var success = document.getElementById("form-success");
      form.style.display = "none";
      if (success) success.classList.add("show");
    });
  }

  document.querySelectorAll("[data-tabs]").forEach(function (group) {
    var btns = group.querySelectorAll("[data-tab]");
    var panels = group.querySelectorAll("[data-panel]");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-tab");
        btns.forEach(function (b) { b.classList.toggle("active", b === btn); });
        panels.forEach(function (p) { p.classList.toggle("active", p.getAttribute("data-panel") === key); });
      });
    });
  });

  document.querySelectorAll("[data-explorer]").forEach(function (group) {
    var tabs = group.querySelectorAll(".svc-tab");
    var details = group.querySelectorAll(".svc-detail");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var key = tab.getAttribute("data-key");
        tabs.forEach(function (t) { t.classList.toggle("active", t === tab); });
        details.forEach(function (d) { d.classList.toggle("active", d.getAttribute("data-detail") === key); });
      });
    });
  });

  document.querySelectorAll("[data-stepper]").forEach(function (group) {
    var nodes = group.querySelectorAll(".step-node");
    var details = group.querySelectorAll(".step-detail");
    nodes.forEach(function (node) {
      node.addEventListener("click", function () {
        var key = node.getAttribute("data-step");
        nodes.forEach(function (n) { n.classList.toggle("active", n === node); });
        details.forEach(function (d) { d.classList.toggle("active", d.getAttribute("data-stepdetail") === key); });
      });
    });
  });

  document.querySelectorAll("[data-accordion]").forEach(function (acc) {
    acc.querySelectorAll(".acc-head").forEach(function (head) {
      head.addEventListener("click", function () {
        var item = head.closest(".acc-item");
        var isOpen = item.classList.contains("open");
        acc.querySelectorAll(".acc-item").forEach(function (i) { i.classList.remove("open"); });
        if (!isOpen) item.classList.add("open");
      });
    });
  });

  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dur = 1100, start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toString();
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = target.toString();
    }
    requestAnimationFrame(tick);
  }

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.target.hasAttribute("data-count")) animateCount(e.target);
        e.target.classList.add("in");
        io.unobserve(e.target);
      });
    }, { threshold: 0.2 });
    document.querySelectorAll("[data-count], .reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }
  if (prefersReduced) {
    document.querySelectorAll("[data-count]").forEach(function (el) {
      el.textContent = el.getAttribute("data-count");
    });
  }

  document.querySelectorAll("[data-footprint]").forEach(function (group) {
    var btns = group.querySelectorAll(".region-filter .tab-btn");
    var offices = group.querySelectorAll(".office");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var region = btn.getAttribute("data-region");
        btns.forEach(function (b) { b.classList.toggle("active", b === btn); });
        offices.forEach(function (o) {
          var match = region === "all" || o.getAttribute("data-region") === region;
          o.classList.toggle("dim", !match);
        });
      });
    });
  });

  document.querySelectorAll("[data-carousel]").forEach(function (carousel) {
    var track = carousel.querySelector(".nc-track");
    if (!track) return;
    var scope = carousel.closest(".section") || document;
    var prev = scope.querySelector("[data-carousel-prev]");
    var next = scope.querySelector("[data-carousel-next]");
    function step() {
      var card = track.querySelector(".post");
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 24;
      return card ? card.getBoundingClientRect().width + gap : 360;
    }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    var anim;
    function animateTo(target) {
      target = Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth));
      if (anim) cancelAnimationFrame(anim);
      var start = track.scrollLeft, delta = target - start, t0 = null, dur = 360;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = start + delta * eased;
        update();
        if (p < 1) anim = requestAnimationFrame(frame);
      }
      anim = requestAnimationFrame(frame);
    }
    if (prev) prev.addEventListener("click", function () { animateTo(track.scrollLeft - step()); });
    if (next) next.addEventListener("click", function () { animateTo(track.scrollLeft + step()); });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });

  var bioModal = null;
  function closeBioModal() {
    if (bioModal) { bioModal.classList.remove("open"); document.body.style.overflow = ""; }
  }
  function ensureBioModal() {
    if (bioModal) return bioModal;
    bioModal = document.createElement("div");
    bioModal.id = "bio-modal";
    bioModal.innerHTML =
      '<div class="bm-backdrop"></div>' +
      '<div class="bm-panel" role="dialog" aria-modal="true">' +
      '<button class="bm-close" type="button" aria-label="Close">&times;</button>' +
      '<div class="bm-head"><img class="bm-photo" src="" alt="" /><div><div class="bm-name"></div><div class="bm-title"></div></div></div>' +
      '<div class="bm-body"></div>' +
      '</div>';
    document.body.appendChild(bioModal);
    bioModal.querySelector(".bm-backdrop").addEventListener("click", closeBioModal);
    bioModal.querySelector(".bm-close").addEventListener("click", closeBioModal);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeBioModal(); });
    return bioModal;
  }
  document.querySelectorAll(".bio-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var card = btn.closest(".tm, .founder");
      if (!card) return;
      var m = ensureBioModal();
      var img = card.querySelector("img.hs");
      var name = card.querySelector(".tnm, .fname");
      var title = card.querySelector(".ttl, .ftag");
      var bio = card.querySelector(".tbio");
      m.querySelector(".bm-photo").src = img ? img.src : "";
      m.querySelector(".bm-name").textContent = name ? name.textContent : "";
      m.querySelector(".bm-title").textContent = title ? title.textContent : "";
      m.querySelector(".bm-body").innerHTML = bio ? bio.innerHTML : "";
      m.querySelector(".bm-panel").scrollTop = 0;
      m.querySelector(".bm-body").scrollTop = 0;
      m.classList.add("open");
      document.body.style.overflow = "hidden";
    });
  });

  if (window.lucide) window.lucide.createIcons();
})();
